/**
 * temporalResolver.js
 *
 * Phase 7B — resolves a stored temporalInput into the concrete
 * forecastDates array executeTimeSeriesQuery() needs, at execution time.
 * This is the ONE place that resolution logic lives — the exact same
 * pattern already used and verified in every Phase 5D/6B/Step-4 Test
 * Harness (loadForecastVersions('direct') + loadForecastVersions
 * ('indirect'), unioned, deduplicated, sorted) — no new logic invented,
 * only centralized so the Report Builder doesn't duplicate it.
 */

import { loadForecastVersions } from './buildCostControlData'

/**
 * @param {string} projectId
 * @returns {Promise<string[]>} sorted, deduplicated forecast_date strings
 */
export async function resolveAllAvailableSnapshots(projectId) {
  const [directVersions, indirectVersions] = await Promise.all([
    loadForecastVersions(projectId, 'direct'),
    loadForecastVersions(projectId, 'indirect'),
  ])
  const dates = [...new Set([
    ...directVersions.revisions.map(r => r.forecast_date),
    ...indirectVersions.revisions.map(r => r.forecast_date),
  ])].sort()
  return dates
}
